import React, { useEffect, useMemo, useState } from 'react'
import { allQuestionsFilter, getQuestionTypeFilter } from '../filters'
import { AssignableNodeTypes, QuestionType } from 'shared/types/ingestion'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { ContentFilterType } from '../types'
import { createIdMap } from '../../../version_mapping/utility'
import { Box } from '@mui/material'
import { InfoDisplay } from '../../../utility/Containers'
import { QuestionTypeSelector } from '../../explore/NodeTypeSelector'
import { ContentFilter } from '../ContentFilter'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { ILeaf, INode } from 'shared/types/tree'
import { isNode } from 'shared/utils'
import { getQuestionType } from '../../../utility/TreeHelpers'
import { closestAncestorOfType } from '../../../utility/TreeNavigation'

export function AllQuestions({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const [currentFilter, setCurrentCurrentFilter] = useState({
    ...allQuestionsFilter,
  })
  const [questionTypes, setQuestionTypes] = useState<QuestionType[]>([])
  const { tree } = useGetTreeById({ treeId, versionId })
  const [contents, setContents] = useState<ContentFilterType>({})

  const idMap = useMemo(() => {
    return tree && createIdMap(tree)
  }, [tree])

  useEffect(() => {
    setCurrentCurrentFilter({
      ...getQuestionTypeFilter(...questionTypes),
      withContent: contents,
    })
  }, [questionTypes, contents])

  return (
    <Box>
      <InfoDisplay>
        <Box>All Questions</Box>
      </InfoDisplay>
      <Box>
        <QuestionTypeSelector
          selectedTypes={questionTypes}
          typeAttrs={{}}
          selectionChanged={(types) =>
            setQuestionTypes(types as QuestionType[])
          }
        />
      </Box>
      <Box>
        <ContentFilter
          contentFilters={contents}
          onFiltersChanged={(f) => setContents(f)}
        />
      </Box>
      <FilteredTreeTable
        filter={currentFilter}
        treeId={treeId}
        versionId={versionId}
        customColumns={[
          {
            title: 'QuestionType',
            rowContent(param: INode | ILeaf) {
              if (isNode(param)) {
                return getQuestionType(param)
              }
            },
          },
          {
            title: 'Assignable Title',
            rowContent(param) {
              if (!idMap) return ''
              return closestAncestorOfType(param, idMap, ...AssignableNodeTypes)
                ?.title
            },
          },
        ]}
      />
    </Box>
  )
}
